import { DateTime } from 'luxon'
import { DateServiceParams } from './types'

/**
 * DateService class for date formatting and conversion.
 */
export class DateService {
  public dateFormat: string
  public timeFormat: string
  public dateTimeFormat: string

  /**
   * Creates an instance of DateService.
   * @param {DateServiceParams} params - The date and time formats.
   * @throws {Error} If dateFormat or timeFormat is not provided.
   */
  constructor({ dateFormat, timeFormat }: DateServiceParams) {
    if (!dateFormat) throw new Error('dateFormat is required')
    if (!timeFormat) throw new Error('timeFormat is required')
    this.dateFormat = dateFormat
    this.timeFormat = timeFormat
    this.dateTimeFormat = `${dateFormat} ${timeFormat}`
  }

  public fromISOToFormat = (ISODate: string, fmt: string = this.dateFormat): string => {
    return DateTime.fromISO(ISODate).toFormat(fmt)
  }

  public fromLuxonToFormat = (luxonDate: DateTime, fmt = this.dateFormat): string => {
    return luxonDate.toFormat(fmt)
  }

  public fromLuxonToISO = (luxonDate: DateTime) => {
    return luxonDate.toUTC().toISO()
  }

  public fromFormatToISO = (dateFormat: string, fmt = this.dateFormat): string => {
    return DateTime.fromFormat(dateFormat, fmt).toUTC().toISO() ?? ''
  }

  public fromFormatToISODate = (dateFormat: string, fmt = this.dateFormat) => {
    return DateTime.fromFormat(dateFormat, fmt).toUTC().toISODate() ?? ''
  }
}
